import React, { useState } from 'react';
import formatDate from '../../utils/formatDate';
import formatDuration from '../../utils/formatDuration';

export default function CallList({ calls, onSelectCall, onDeleteCall, onBulkDeleteCalls }) {
  const [confirmId, setConfirmId] = useState(null);
  const [selected, setSelected] = useState(new Set());
  const [confirmBulk, setConfirmBulk] = useState(false);

  if (!calls || calls.length === 0) {
    return <div className="card"><p>No calls recorded yet.</p></div>;
  }

  const allSelected = calls.length > 0 && selected.size === calls.length;

  const toggleSelect = (callId) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(callId)) next.delete(callId);
      else next.add(callId);
      return next;
    });
  };

  const toggleAll = () => {
    if (allSelected) {
      setSelected(new Set());
    } else {
      setSelected(new Set(calls.map((c) => c.call_id)));
    }
  };

  const handleBulkDelete = () => {
    if (confirmBulk) {
      onBulkDeleteCalls([...selected]);
      setSelected(new Set());
      setConfirmBulk(false);
    } else {
      setConfirmBulk(true);
    }
  };

  const handleDelete = (e, callId) => {
    e.stopPropagation();
    if (confirmId === callId) {
      onDeleteCall(callId);
      setConfirmId(null);
    } else {
      setConfirmId(callId);
    }
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    setConfirmId(null);
  };

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <h3 style={{ margin: 0 }}>Recent Calls</h3>
        {selected.size > 0 && (
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <span style={{ fontSize: '0.85rem', color: '#666' }}>{selected.size} selected</span>
            {confirmBulk ? (
              <>
                <button className="btn-danger-sm" onClick={handleBulkDelete}>
                  Delete {selected.size}?
                </button>
                <button className="btn-secondary-sm" onClick={() => setConfirmBulk(false)}>Cancel</button>
              </>
            ) : (
              <button className="btn-danger-sm" onClick={handleBulkDelete}>
                Delete Selected
              </button>
            )}
          </div>
        )}
      </div>
      <table>
        <thead>
          <tr>
            <th style={{ width: '30px' }}>
              <input type="checkbox" checked={allSelected} onChange={toggleAll} />
            </th>
            <th>Call ID</th>
            <th>Date</th>
            <th>Duration</th>
            <th>Sentiment</th>
            <th>Callback</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {calls.map((call) => (
            <tr
              key={call.call_id}
              onClick={() => onSelectCall(call.call_id)}
              style={{ cursor: 'pointer', background: selected.has(call.call_id) ? '#edf2f7' : undefined }}
            >
              <td onClick={(e) => e.stopPropagation()}>
                <input
                  type="checkbox"
                  checked={selected.has(call.call_id)}
                  onChange={() => toggleSelect(call.call_id)}
                />
              </td>
              <td style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
                {call.call_id}
              </td>
              <td>{formatDate(call.created_at)}</td>
              <td>{formatDuration(call.duration)}</td>
              <td>
                <span className={`badge badge-${call.summary?.sentiment?.label || 'neutral'}`}>
                  {call.summary?.sentiment?.label || 'n/a'}
                </span>
              </td>
              <td>
                {call.summary?.callback_detection?.detected
                  ? <span className="badge badge-initiated">Yes</span>
                  : <span className="badge badge-neutral">No</span>
                }
              </td>
              <td onClick={(e) => e.stopPropagation()} style={{ whiteSpace: 'nowrap' }}>
                {confirmId === call.call_id ? (
                  <>
                    <button className="btn-danger-sm" onClick={(e) => handleDelete(e, call.call_id)}>Confirm</button>
                    {' '}
                    <button className="btn-secondary-sm" onClick={handleCancel}>Cancel</button>
                  </>
                ) : (
                  <button className="btn-icon" onClick={(e) => handleDelete(e, call.call_id)} title="Delete">&#128465;</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
